import { getComponentElement } from "./baseComponent.helpers";
import { HTMLElementAttribute } from "./misc.enums";
export class CdpaTooltip {
    constructor(node) {
        this.tooltip = getComponentElement(node.closest(CdpaTooltip.selector));
    }
    setLabel(value) {
        if (value) {
            this.tooltip.setAttribute(HTMLElementAttribute.Tooltip, value);
        }
        else {
            this.tooltip.removeAttribute(HTMLElementAttribute.Tooltip);
        }
    }
}
CdpaTooltip.selector = ".cdpa-tooltip";
